/* @flow */

import type { State } from 'src/shared/core/type/reduxTypes';

export function isVideoOverlayForced(state: State): boolean {
  return state.ui.virtualBraindate.forceVideoOverlay;
}

export function isVirtualBraindateOverlayShown(state: State): boolean {
  return state.ui.virtualBraindate.isOverlayShown;
}

export function isVirtualBraindateTimezoneConfirmed(state: State): boolean {
  return state.ui.virtualBraindate.isTimezoneConfirmed;
}
